import * as Yup from 'yup'

import { FC, HTMLAttributes, useEffect } from "react"

import { FieldError } from '../../../../../widgets'
import { ICheckBoxProps } from './ICheckBoxProps'
import { IEntity } from "../../../../../base/types"
import clsx from 'clsx'
import { useCheckBoxValidationSchema } from './CheckBoxValidationSchema'
import { useFormContext } from '../../form'
import { useFormikContext } from "formik"

interface ICheckBoxFieldProps extends HTMLAttributes<HTMLInputElement>, ICheckBoxProps {
    name: string
}

export const CheckBoxField: FC<ICheckBoxFieldProps> = (props) => {
    const { id, name, className, title, disabled } = props
    const shape = useCheckBoxValidationSchema(props)
    const { getFieldProps, errors, touched } = useFormikContext<IEntity>() || {}
    const { updateSchema } = useFormContext()

    useEffect(() => {
        if (!name || !shape) return;

        const schema = Yup.object().shape({ [name]: shape });
        updateSchema(schema);

        // eslint-disable-next-line
    }, [name, shape])

    let fieldProps = getFieldProps(`['${name}']`);
    if (fieldProps.value === undefined)
        fieldProps = { ...fieldProps, value: false }
    else
        fieldProps = { ...fieldProps, value: Boolean(fieldProps.value) }

    return <>
        <input
            type="checkbox"
            id={id}
            title={title}
            {...fieldProps}
            className={clsx(className, "form-check-input")}
            checked={fieldProps.value}
            disabled={disabled}
        />
        <FieldError show={touched[name] && !!errors[name]} message={`${errors[name]}`} />
    </>
}
